import { useStoreState } from 'easy-peasy';
import {
  jobClientSelector,
  jobClientsSelector,
} from '@model/Job/Job.selectors';
import { selectorUser } from '@model/User';
import { useMemo } from 'react';
import type { TUserPackageVisibility } from '@components/ShareLinkModal/ShareLinkModal.types';

export const USER_TYPE = {
  MANAGER: 'manager',
  GUEST: 'guest',
  MAIN_CLIENT: 'mainClient',
} as const;

export const useUserPackageVisibility = (): TUserPackageVisibility => {
  const currentUser = useStoreState(selectorUser);
  const jobClients = useStoreState(jobClientsSelector);
  const jobMainClient = useStoreState(jobClientSelector);

  return useMemo(() => {
    if (currentUser.type === USER_TYPE.MANAGER) {
      return { type: USER_TYPE.MANAGER, isVisible: true, isEditable: true };
    }

    if (currentUser.id === jobMainClient?.id) {
      return { type: USER_TYPE.MAIN_CLIENT, isVisible: true, isEditable: true };
    }

    const client = jobClients.find(c => c.clientId === currentUser.id);

    if (client) {
      return {
        type: USER_TYPE.GUEST,
        isVisible: client.isCompensationPackageVisible,
        isEditable: false,
      };
    }

    return {
      type: USER_TYPE.GUEST,
      isVisible: false,
      isEditable: false,
    };
  }, [currentUser, jobClients, jobMainClient]);
};
